import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconFileUploadLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.025 20.975c.35.35.778.525 1.283.525h11.384c.505 0 .933-.175 1.283-.525.35-.35.525-.778.525-1.283V8.498c0-.241-.047-.473-.14-.695a1.794 1.794 0 0 0-.387-.58l-4.196-4.196a1.794 1.794 0 0 0-.58-.387 1.775 1.775 0 0 0-.695-.14H6.308c-.505 0-.933.175-1.283.525-.35.35-.525.778-.525 1.283v15.384c0 .505.175.933.525 1.283ZM13.5 4v3.596c0 .258.086.473.259.645a.875.875 0 0 0 .645.259H18v11.192a.294.294 0 0 1-.096.212.294.294 0 0 1-.212.096H6.308a.294.294 0 0 1-.212-.096.294.294 0 0 1-.096-.212V4.308c0-.077.032-.148.096-.212A.294.294 0 0 1 6.308 4H13.5Zm-2.25 9.496v3.685c0 .213.072.39.216.534a.726.726 0 0 0 .534.216.726.726 0 0 0 .535-.216.726.726 0 0 0 .215-.534v-3.685l1.323 1.323c.075.075.159.13.251.167a.65.65 0 0 0 .28.049.853.853 0 0 0 .275-.064.784.784 0 0 0 .473-.694.7.7 0 0 0-.225-.527l-2.494-2.494A.832.832 0 0 0 12 11a.832.832 0 0 0-.633.256L8.874 13.75a.705.705 0 0 0-.22.522c.002.2.08.377.236.532a.78.78 0 0 0 .527.225.7.7 0 0 0 .527-.225l1.307-1.308Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
      />
    </Svg>
  );
};

export default IconFileUploadLine;
